import React, { useMemo } from 'react';
import { Info, Check, Times } from '../../../Icon';
import styles from './PerkItem.module.scss';
import { Perk } from '../interfaces';

export type PerkItemProps = Pick<Perk, 'perk' | 'included' | 'tooltip'>;

const PerkItem: React.FC<PerkItemProps> = ({ perk, included, tooltip }) => {
  const tooltipStyles = useMemo(() => {
    if (tooltip.length && tooltip.length < 75) {
      return `${styles.plansTooltip} ${styles.plansTooltipShort}`;
    }

    return styles.plansTooltip;
  }, [tooltip.length]);

  const perkIcon = included ? <Check /> : <Times />;

  return (
    <li className={`${included ? '' : styles.perkExcluded} ${styles.perk}`}>
      <span className={styles.perkIcon}>{perkIcon}</span>
      <div className={styles.perkText}>
        <p>
          {perk}
          {tooltip && (
            <span
              onClick={(e) => e.stopPropagation()}
              className={tooltipStyles}
              data-tooltip={tooltip}
            >
              <Info fill="#CCCCCC" />
            </span>
          )}
        </p>
      </div>
    </li>
  );
};

export default PerkItem;
